/**
 * CHN Custom Mobile Drawer
 * Accordion expand/collapse + drawer open/close
 */

class DrawerCustom extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.drawer = this.querySelector('.drawer-custom');
    this.closeBtn = this.querySelector('.drawer-custom__close');
    this.accordions = this.querySelectorAll('.drawer-custom__accordion-trigger');
  }

  connectedCallback() {
    if (!this.details || !this.drawer) return;

    // Toggle drawer on hamburger click
    this.summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (this.details.open) {
        this.close();
      } else {
        this.open();
      }
    });

    // Close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.details.open) this.close();
    });

    // Accordion toggles
    this.accordions.forEach((trigger) => {
      trigger.addEventListener('click', () => this.toggleAccordion(trigger));
    });
  }

  open() {
    this.details.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    // Allow paint before transition
    requestAnimationFrame(() => {
      this.details.classList.add('menu-opening');
    });
  }

  close() {
    document.body.style.overflow = '';
    this.details.classList.remove('menu-opening');
    // Wait for transition before removing open
    setTimeout(() => {
      this.details.removeAttribute('open');
    }, 300);
  }

  toggleAccordion(trigger) {
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    const content = trigger.nextElementSibling;

    if (expanded) {
      // Collapse
      trigger.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
    } else {
      // Expand - collapse others first (single-open accordion)
      this.accordions.forEach((other) => {
        if (other !== trigger) {
          other.setAttribute('aria-expanded', 'false');
          other.nextElementSibling.setAttribute('aria-hidden', 'true');
        }
      });
      trigger.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
    }
  }
}

customElements.define('drawer-custom', DrawerCustom);
